<script setup lang="ts">
const supabase = useSupabase()
const toast = useToast()

async function signIn() {
    const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
            redirectTo: useRequestURL().origin,
        },
    })

    if (error) {
        toast.add({
            color: 'error',
            title: 'An error occurred',
            description: 'Please try again later.',
        })
    }
}
</script>

<template>
    <UButton icon="logos:google-icon" color="neutral" variant="outline" @click="signIn">Continue with Google</UButton>
</template>